import React, { useCallback } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
//
import { FormInputProps } from '../../componets/form/formInterfaces';
import {
    IFormProps,
    ImperativeHandleAccessedByParentComponent,
} from '../../componets/interfaces/formProps';
import FormComplete from '../../componets/form/formComplete';

interface IFormInput extends FieldValues {
    description: string;
}

const defaultValues = {};

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;

    const { control } = useForm<IFormInput>({
        defaultValues,
    });

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm: FormInputProps<IFormInput>[] = [
        {
            typeInput: 'text',
            name: 'description',
            control: control,
            label: 'Descrição',
            loadingAutocomplete: false,
            md: 3,
            xs: 12,
            rules: {
                required: true,
            },
            messagesError: [
                {
                    type: 'required',
                    message: 'O campo descrição é obrigatório',
                },
            ],
        },
    ];

    const implSetValueData = useCallback((data: IFormInput) => {
        if (refForm?.current?.setValue) {
            refForm?.current?.setValue('description', data.description);
        }
    }, []);

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={inputsForm}
            ref={refForm}
            settings={settings}
            implSetValueData={implSetValueData}
        />
    );
};

export default Form;
